import {
  CommonRepository,
} from '@bingads-webui-campaign/targeting-settings-scaffolds';

export default class LocationsRepository extends CommonRepository {
  get hiddenFilter() {
    return {
      query: {
        $or: [
          {
            Criterion: {
              $isof: "'Model.LocationCriterion'",
            },
          },
          {
            Criterion: {
              $isof: "'Model.RadiusCriterion'",
            },
          },
        ],
      },
    };
  }
}
